export const ASSET_TYPE_LABELS = {
    1: "Ação",
    2: "FII",
    3: "BDR",
    4: "ETF",
    5: "Fundo de investimento",
    6: "CDI",
    7: "Customizado",
    8: "Moeda",
    9: "Cripto",
};

export const CUSTOM_ASSET_TYPE = 7;

export const getAssetTypeLabel = (type) => ASSET_TYPE_LABELS[Number(type)] ?? "Outro";

const compareByName = (a, b) =>
    (a.name ?? "").localeCompare(b.name ?? "", "pt-BR", { sensitivity: "base" });

export const buildGlobalPosition = (positions) =>
    positions.map((item) => ({
        name: item.name,
        value: Number(item.value) || 0,
    }));

export const buildAllocationByType = (positions) => {
    const totalWallet = positions.reduce((total, item) => total + (Number(item?.value) || 0), 0);

    if (totalWallet <= 0) {
        return [];
    }

    const groupedByType = positions.reduce((acc, item) => {
        const assetTypeLabel = getAssetTypeLabel(item?.type);
        const value = Number(item?.value) || 0;
        const assetDisplayName =
            Number(item?.type) === CUSTOM_ASSET_TYPE && item?.customAssetCategoryName
                ? item.customAssetCategoryName
                : item?.name ?? "Ativo sem nome";

        if (value <= 0) {
            return acc;
        }

        if (!acc[assetTypeLabel]) {
            acc[assetTypeLabel] = {
                totalValue: 0,
                assets: [],
            };
        }

        acc[assetTypeLabel].totalValue += value;
        acc[assetTypeLabel].assets.push({
            name: assetDisplayName,
            value,
        });

        return acc;
    }, {});

    return Object.entries(groupedByType)
        .map(([name, group]) => ({
            name,
            value: (group.totalValue / totalWallet) * 100,
            assets: Object.values(
                group.assets.reduce((acc, asset) => {
                    if (!acc[asset.name]) {
                        acc[asset.name] = {
                            name: asset.name,
                            value: 0,
                        };
                    }

                    acc[asset.name].value += asset.value;

                    return acc;
                }, {})
            )
                .map((asset) => ({
                    name: asset.name,
                    value: group.totalValue > 0 ? (asset.value / group.totalValue) * 100 : 0,
                }))
                .sort(compareByName),
        }))
        .sort(compareByName);
};
